import { http } from '@/api/client/httpClient';
import type { PagedResult } from '@/api/types/abp';
import type { TradeBlotterFilterInput, TradeBlotterRowDto } from '@/api/types/tradeBlotter';

const BASE = '/api/app/trade-blotter';

export const tradeBlotterApi = {
  getRows: (input: TradeBlotterFilterInput) =>
    http.get<PagedResult<TradeBlotterRowDto>>(`${BASE}/rows`, { params: input, paramsSerializer: { indexes: null } }).then((r) => r.data),
  pingViewing: () => http.post(`${BASE}/ping-viewing`).then((r) => r.data),
  getConnectorWarning: (input: TradeBlotterFilterInput) =>
    http.get<{ message?: string | null }>(`${BASE}/connector-warning`, { params: input, paramsSerializer: { indexes: null } }).then((r) => r.data),
  excelUrl: `${BASE}/excel`,
};
